import { GoogleCaf } from "../utils/consts";

export function getArrowPageLevel() {
  return {
    styleId: GoogleCaf.styleId.ARROW,
  };
}

export function getSimple2CLightPageLevel() {
  return {
    uiOptimize: true,
    styleId: GoogleCaf.styleId.SIMPLE_2C_LIGHT,
  };
}

export function getSimple2CSearchbox() {
  return {
    radiusSearchInputBorder: "5px", // Use this parameter to add rounded borders to the search input field AND the search button.
    heightSearchInput: "22px",
    heightSearchButton: "22px",
    fontSizeSearchInput: "12px",
    fontSizeSearchButton: "12px",
  };
}

export function getSimple2CRelatedLinks() {
  return {
    rolloverLinkColor: "#5595E9",
    colorAttribution: "#b4b4b4",
    colorBackground: "transparent",
    attributionSpacingBelow: "2",
    attributionUppercase: false,
    attributionBold: false,
    fontSizeAttribution: "11px",
    colorTitleLink: "#e08d20",
    titleBold: false,
    fontSizeTitle: "24",
    lineHeightTitle: "40",
    noTitleUnderline: true,
    adIconUrl:
      "https://afs.googleusercontent.com/dp-namemedia/bullet-arrows-orange.png",
    adIconHeight: "18", // Required (if adIconUrl is set)
    adIconWidth: "18", // Required (if adIconUrl is set)
    adIconSpacingAbove: "10",
    adIconSpacingAfter: "10",
    verticalSpacing: "2",
    adBorderSelections: "bottom",
    colorAdBorder: "#525252",
  };
}

export function getSimple2CLightRelatedLinks() {
  return {
    ...getSimple2CRelatedLinks(),
    rolloverLinkColor: "#5595E9",
    colorAttribution: "#2b2b2b",
    colorTitleLink: "#e08d20",
    colorAdBorder: "#525252",
    colorText: "#666666",
  };
}

export function getSimple2CAds() {
  return {
    colorBackground: "transparent",
    colorText: "#f8f8f8",
    rolloverLinkColor: "#5595E9",
    rolloverLinkUnderline: false,
    adIconUrl:
      "https://afs.googleusercontent.com/dp-namemedia/bullet-arrows-orange.png",
    adIconHeight: "22",
    adIconWidth: "22",
    adIconSpacingAbove: "10",
    adIconSpacingAfter: "10",
    verticalSpacing: "24",
    colorAdSeparator: "#525252",
    linkTarget: "_blank",
    attributionSpacingBelow: "10",
    attributionUppercase: false,
    colorAttribution: "#b4b4b4",
    fontSizeAttribution: "10",
    attributionBold: false,
    colorTitleLink: "#e08d20",
    fontSizeTitle: "20",
    noTitleUnderline: true,
    lineHeightTitle: "35",
    titleBold: false,
    fontSizeDescription: "16",
    lineHeightDescription: "28",
    colorDomainLink: "#5595E9",
    fontSizeDomainLink: "16",
    lineHeightDomainLink: "28",
  };
}

export function getSimple2CLightAds() {
  return {
    ...getSimple2CAds(),
    colorText: "#f8f8f8",
    rolloverLinkColor: "#5595E9",
    colorAdSeparator: "#525252",
    colorAttribution: "#b4b4b4",
    colorTitleLink: "#e08d20",
    colorDomainLink: "#5595E9",
  };
}
